import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body {
    padding: 0;
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Apple Color Emoji',
        'Segoe UI Emoji', 'Segoe UI Symbol', 'Segoe UI', 'PingFang SC',
        'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica,
        Arial, sans-serif;
      width: 100%;
      height: 100%;
      font-size: 12px;
      color: rgb(76, 76, 76);
  }
  #root{
    width: 100%;
    height: 100%;
    /* min-width: 1200px; */
    .amid {
      width: 1200px;
      margin: 0 auto;
    }
  }
  .acontent{
    margin-left: 200px;
  }

  /** flex **/
  .fac { display: flex; align-items: center;}
  .jsc { display: flex; align-items: center; justify-content: center;}
  .jssb { display: flex; align-items: center; justify-content: space-between;}
  .jssa { display: flex; align-items: center; justify-content: space-around;}
  .sb {justify-content: space-between;}
  .sc {justify-content: center}
  .f{ display: flex !important;}
  .ac{ align-items: center !important;}
  .f1 { flex: 1 !important;}
  .f0 { flex: 0 !important; }
  .fc{ flex-direction: column !important;}

  .p {cursor: pointer !important;}
  .tc{text-align: center;}

  .link{color:#1890ff !important;}
  .cw{color: white !important;}

  .br{background: red}
  .bg{background: #efefef;}
  .hidden{
    overflow: hidden;
  }

  .fl{float: left;}
  .break{
    word-wrap: break-word;
    word-break: break-all;
  }


  .wp10{width: 10% !important;}
  .wp20{width: 20% !important;}
  .wp30{width: 30% !important;}
  .wp40{width: 40% !important;}
  .wp50{width: 50% !important;}
  .wp60{width: 60% !important;}
  .wp70{width: 70% !important;}
  .wp80{width: 80% !important;}
  .wp90{width: 90% !important;}
  .wp100{width: 100% !important;}
  .wp15{width: 15% !important;}
  .wp25{width: 25% !important;}
  .wp35{width: 35% !important;}
  .wp45{width: 45% !important;}
  .wp55{width: 55% !important;}
  .wp65{width: 65% !important;}
  .wp75{width: 75% !important;}
  .wp85{width: 85% !important;}
  .wp95{width: 95% !important;}

  .fw1{font-weight: 100 !important;}
  .fw2{font-weight: 200 !important;}
  .fw3{font-weight: 300 !important;}
  .fw4{font-weight: 400 !important;}
  .fw5{font-weight: 500 !important;}
  .fw6{font-weight: 600 !important;}
  .fw7{font-weight: 700 !important;}

  .fs12{font-size: 12px !important;}
  .fs13{font-size: 13px !important;}
  .fs14{font-size: 14px !important;}
  .fs15{font-size: 15px !important;}
  .fs16{font-size: 16px !important;}
  .fs17{font-size: 17px !important;}
  .fs18{font-size: 18px !important;}
  .fs19{font-size: 19px !important;}
  .fs20{font-size: 20px !important;}
  
  .ml5{margin-left:5px !important;}
  .ml10{margin-left:10px !important;}
  .ml15{margin-left:15px !important;}
  .ml20{margin-left:20px !important;}
  .ml25{margin-left:25px !important;}
  .ml30{margin-left:30px !important;}
  .ml35{margin-left:35px !important;}
  .ml40{margin-left:40px !important;}
  .ml45{margin-left:45px !important;}
  .ml50{margin-left:50px !important;}
  
  .mr5{margin-right:5px !important;}
  .mr10{margin-right:10px !important;}
  .mr15{margin-right:15px !important;}
  .mr20{margin-right:20px !important;}
  .mr25{margin-right:25px !important;}
  .mr30{margin-right:30px !important;}
  .mr35{margin-right:35px !important;}
  .mr40{margin-right:40px !important;}
  .mr45{margin-right:45px !important;}
  .mr50{margin-right:50px !important;}

  .mt5{margin-top:5px !important;}
  .mt10{margin-top:10px !important;}
  .mt15{margin-top:15px !important;}
  .mt20{margin-top:20px !important;}
  .mt25{margin-top:25px !important;}
  .mt30{margin-top:30px !important;}
  .mt35{margin-top:35px !important;}
  .mt40{margin-top:40px !important;}
  .mt45{margin-top:45px !important;}
  .mt50{margin-top:50px !important;}

  .mb5{margin-bottom:5px !important;}
  .mb10{margin-bottom:10px !important;}
  .mb15{margin-bottom:15px !important;}
  .mb20{margin-bottom:20px !important;}
  .mb25{margin-bottom:25px !important;}
  .mb30{margin-bottom:30px !important;}
  .mb35{margin-bottom:35px !important;}
  .mb40{margin-bottom:40px !important;}
  .mb45{margin-bottom:45px !important;}
  .mb50{margin-bottom:50px !important;}
///
  .pl5{padding-left:5px !important;}
  .pl10{padding-left:10px !important;}
  .pl15{padding-left:15px !important;}
  .pl20{padding-left:20px !important;}
  .pl25{padding-left:25px !important;}
  .pl30{padding-left:30px !important;}
  .pl35{padding-left:35px !important;}
  .pl40{padding-left:40px !important;}
  .pl45{padding-left:45px !important;}
  .pl50{padding-left:50px !important;}
  
  .pr5{padding-right:5px !important;}
  .pr10{padding-right:10px !important;}
  .pr15{padding-right:15px !important;}
  .pr20{padding-right:20px !important;}
  .pr25{padding-right:25px !important;}
  .pr30{padding-right:30px !important;}
  .pr35{padding-right:35px !important;}
  .pr40{padding-right:40px !important;}
  .pr45{padding-right:45px !important;}
  .pr50{padding-right:50px !important;}

  .pt5{padding-top:5px !important;}
  .pt10{padding-top:10px !important;}
  .pt15{padding-top:15px !important;}
  .pt20{padding-top:20px !important;}
  .pt25{padding-top:25px !important;}
  .pt30{padding-top:30px !important;}
  .pt35{padding-top:35px !important;}
  .pt40{padding-top:40px !important;}
  .pt45{padding-top:45px !important;}
  .pt50{padding-top:50px !important;}

  .pb5{padding-bottom:5px !important;}
  .pb10{padding-bottom:10px !important;}
  .pb15{padding-bottom:15px !important;}
  .pb20{padding-bottom:20px !important;}
  .pb25{padding-bottom:25px !important;}
  .pb30{padding-bottom:30px !important;}
  .pb35{padding-bottom:35px !important;}
  .pb40{padding-bottom:40px !important;}
  .pb45{padding-bottom:45px !important;}
  .pb50{padding-bottom:50px !important;}

  .w10{width:10px !important;}
  .w20{width:20px !important;}
  .w30{width:30px !important;}
  .w40{width:40px !important;}
  .w50{width:50px !important;}
  .w60{width:60px !important;}
  .w70{width:70px !important;}
  .w80{width:80px !important;}
  .w90{width:90px !important;}
  .w100{width:100px !important;}
  .w110{width:110px !important;}
  .w120{width:120px !important;}
  .w130{width:130px !important;}
  .w140{width:140px !important;}
  .w150{width:150px !important;}
  .w160{width:160px !important;}
  .w170{width:170px !important;}
  .w180{width:180px !important;}
  .w190{width:190px !important;}
  .w200{width:200px !important;}
  .w210{width:210px !important;}
  .w220{width:220px !important;}
  .w230{width:230px !important;}
  .w240{width:240px !important;}
  .w250{width:250px !important;}
  .w260{width:260px !important;}
  .w270{width:270px !important;}
  .w280{width:280px !important;}
  .w290{width:290px !important;}
  .w300{width:300px !important;}
  .w310{width:310px !important;}
  .w320{width:320px !important;}
  .w330{width:330px !important;}
  .w340{width:340px !important;}
  .w350{width:350px !important;}
  .w360{width:360px !important;}
  .w370{width:370px !important;}
  .w380{width:380px !important;}
  .w390{width:390px !important;}
  .w400{width:400px !important;}
  .w410{width:410px !important;}
  .w420{width:420px !important;}
  .w430{width:430px !important;}
  .w440{width:440px !important;}
  .w450{width:450px !important;}
  .w460{width:460px !important;}
  .w470{width:470px !important;}
  .w480{width:480px !important;}
  .w490{width:490px !important;}
  .w500{width:500px !important;}


.h10{height:10px !important;}
.h20{height:20px !important;}
.h30{height:30px !important;}
.h40{height:40px !important;}
.h50{height:50px !important;}
.h60{height:60px !important;}
.h70{height:70px !important;}
.h80{height:80px !important;}
.h90{height:90px !important;}
.h100{height:100px !important;}
.h110{height:110px !important;}
.h120{height:120px !important;}
.h130{height:130px !important;}
.h140{height:140px !important;}
.h150{height:150px !important;}
.h160{height:160px !important;}
.h170{height:170px !important;}
.h180{height:180px !important;}
.h190{height:190px !important;}
.h200{height:200px !important;}
.h210{height:210px !important;}
.h220{height:220px !important;}
.h230{height:230px !important;}
.h240{height:240px !important;}
.h250{height:250px !important;}
.h260{height:260px !important;}
.h270{height:270px !important;}
.h280{height:280px !important;}
.h290{height:290px !important;}
.h300{height:300px !important;}
.h310{height:310px !important;}
.h320{height:320px !important;}
.h330{height:330px !important;}
.h340{height:340px !important;}
.h350{height:350px !important;}
.h360{height:360px !important;}
.h370{height:370px !important;}
.h380{height:380px !important;}
.h390{height:390px !important;}
.h400{height:400px !important;}
.h410{height:410px !important;}
.h420{height:420px !important;}
.h430{height:430px !important;}
.h440{height:440px !important;}
.h450{height:450px !important;}
.h460{height:460px !important;}
.h470{height:470px !important;}
.h480{height:480px !important;}
.h490{height:490px !important;}
.h500{height:500px !important;}


.breadCrmb {
  height: 24px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  justify-content: space-between;
}
// 右侧内容
.rightcontent {
  flex: 1;
  margin: 10px;
  display: flex;
  flex-direction: column;
}


`;

/**  */
